import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";
import amber from "@material-ui/core/colors/amber";
import teal from "@material-ui/core/colors/teal";

const defaultTheme: ThemeOptions = {
  palette: {
    primary: teal,
    secondary: amber,
    error: {
      light: "#e57373",
      main: "#f44336",
      dark: "#d32f2f",
      contrastText: "#bd0e02",
    },
    warning: {
      light: "#ffb74d",
      main: "#ff9800",
      dark: "#f57c00",
      contrastText: "#945800",
    },
    info: {
      light: "#64b5f6",
      main: "#2196f3",
      dark: "#1976d2",
      contrastText: "#004073",
    },
    success: {
      light: "#81c784",
      main: "#4caf50",
      dark: "#388e3c",
      contrastText: "#005d04",
    },
    imageControl: {
      // main: "#1aa3cc"
      main: teal[500],
    },
  },
  overrides: {
    MuiButton: {
      root: {
        fontSize: "0.75rem",
      },
    },
    MuiSkeleton: {
      root: {
        backgroundColor: "rgba(0,0,0,0.12)", // theme.palette.action.disabledBackground
      },
    },
  },
};

export default defaultTheme;
